import React from 'react';
import { TableOutlined, AppstoreOutlined } from '@ant-design/icons';

interface GridViewSwitcherProps {
  view: 'table' | 'card';
  onViewChange: (view: 'table' | 'card') => void;
}

export function GridViewSwitcher({ view, onViewChange }: GridViewSwitcherProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      background: 'var(--disabled-bg)',
      borderRadius: '8px',
      border: '1px solid var(--border-color)',
      padding: '4px'
    }}>
      <button
        onClick={() => onViewChange('table')}
        style={{
          padding: '8px',
          borderRadius: '4px',
          border: 'none',
          background: view === 'table' 
            ? 'rgba(45, 55, 75, 0.7)' 
            : 'transparent',
          color: view === 'table' 
            ? 'var(--main-accent)' 
            : 'var(--main-text-secondary)',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        title="Table View"
        onMouseEnter={(e) => {
          if (view !== 'table') {
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.background = 'var(--disabled-bg)';
          }
        }}
        onMouseLeave={(e) => {
          if (view !== 'table') {
            e.currentTarget.style.color = 'var(--main-text-secondary)';
            e.currentTarget.style.background = 'transparent';
          }
        }}
      >
        <TableOutlined style={{ fontSize: '16px' }} />
      </button>
      <button
        onClick={() => onViewChange('card')}
        style={{
          padding: '8px',
          borderRadius: '4px',
          border: 'none',
          background: view === 'card'
            ? 'rgba(45, 55, 75, 0.7)'
            : 'transparent',
          color: view === 'card'
            ? 'var(--main-accent)'
            : 'var(--main-text-secondary)',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        title="Card View"
        onMouseEnter={(e) => {
          if (view !== 'card') {
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.background = 'var(--disabled-bg)';
          }
        }}
        onMouseLeave={(e) => {
          if (view !== 'card') {
            e.currentTarget.style.color = 'var(--main-text-secondary)';
            e.currentTarget.style.background = 'transparent';
          }
        }}
      >
        <AppstoreOutlined style={{ fontSize: '16px' }} />
      </button>
    </div>
  );
}
